import { Component, Input, OnInit } from '@angular/core';
import { CalibrationDelivery_Interface, Empty_CalibrationDelivery_Interface } from 'src/app/Interface/CalibrationDelivery_Interface';
import { Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { CalibrationDeliveryService } from 'src/app/Service/CalibrationDelivery/CalibrationDelivery.service';

@Component({
  selector: 'app-CalibrationDeliveryView',
  templateUrl: './CalibrationDeliveryView.component.html',
  styleUrls: ['./CalibrationDeliveryView.component.scss']
})
export class CalibrationDeliveryViewComponent implements OnInit {
  
  Token: String = ""
  InProccessing:boolean=false
  @Input() inner_Record:CalibrationDelivery_Interface=Empty_CalibrationDelivery_Interface()
  MainRecord:any
  Data_List_Calibration:Array<Calibration_Interface>=[]

  constructor(
    private CalibrationDelivery_Service: CalibrationDeliveryService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.GetRecord()
  }

  GetRecord(){
    this.CalibrationDelivery_Service.GetSingle(this.Token,this.inner_Record.id).subscribe(
      data=>{
        this.InProccessing=true
        this.MainRecord=data['result']
        this.Data_List_Calibration=data['device']
      }
    )
  }

}
